import React from 'react'
import { connect } from 'react-redux'
import {
  actions as formActions,
  Form as ReactReduxForm,
  getField,
  getModel
} from 'react-redux-form'

import * as v from './validations.js'

export const publishErrors = (model, errors) => dispatch => {
  errors
    .filter(e => e.type === 'field')
    .forEach(error => {
      const fieldModel = `${model}.${error.field}`

      dispatch(formActions.setErrors(fieldModel, { server: error.error }))
    })
  const global = errors.find(e => e.type === 'global')

  if (global) {
    dispatch(formActions.setErrors(model, global))
  }
}

class Form extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fieldValidations: {}
    }
  }

  componentDidMount() {
    //Validate on mount, can't dispatch directly within render loop
    setTimeout(() => this.validate(this.props.modelValues), 1)
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const oldModel = prevProps.model
    const newModel = this.props.model
    const modelChanged = oldModel !== newModel
    const oldFieldValidations = prevState.fieldValidations
    const newFieldValidations = this.state.fieldValidations
    const fieldValidationsChanged = oldFieldValidations !== newFieldValidations

    if (modelChanged || fieldValidationsChanged) {
      //Validate on update of any validation info, can't dispatch directly within render loop
      setTimeout(() => this.validate(this.props.modelValues), 1)
    }
  }

  /*
   * Pass in null for validations to remove
   */
  setFieldValidations(fieldModel, validations) {
    let fieldKey = fieldModel
    const model = this.props.model
    const indexOf = fieldModel.indexOf(model)

    if (indexOf === 0) {
      fieldKey = fieldModel.substring(model.length + 1)
    }

    //console.log("Setting field validations for", fieldKey, "in", this.props.model);
    this.setState(state => {
      if (!validations) {
        const newFieldValidations = { ...state.fieldValidations }

        delete newFieldValidations[fieldKey]

        return newFieldValidations
      }

      return {
        ...state,
        fieldValidations: {
          ...state.fieldValidations,
          [fieldKey]: validations.map(validation => v.targetField(fieldKey, validation))
        }
      }
    })
  }

  /*
   * Passes in the form model state and validates immediately
   */
  validate(modelValues) {
    //{ fieldName: [ (form) -> { validationType: message? } ]? }
    let formValidations = this.props.validate || {}

    for (const field in this.state.fieldValidations) {
      const formLevel = formValidations[field] || []
      const fieldLevel = this.state.fieldValidations[field] || []

      formValidations = {
        ...formValidations,
        [field]: [...fieldLevel, ...formLevel]
      }
    }

    const validateForm = v.validateForm(this.props.model, formValidations)(modelValues)

    return this.props.dispatch(validateForm)
  }

  render() {
    const {
      model,
      errors,
      onChange,
      onSubmit,
      children,
      onValidationErrors,
      dispatch,
      ...props
    } = this.props

    // console.log("required = ", required, "allValidators =", allValidators)

    const enhancedOnChange = form => {
      //console.log("Form changed", model, form, {formValidations: this.props.validate, fieldValidations: this.state.fieldValidations});
      this.validate(form)
      onChange && onChange(form)
    }
    const enhancedOnSubmit = form => {
      //console.log("Form submitted", model, form);
      dispatch(formActions.setPending(model))
      this.validate(form).then(valid => {
        //console.log("Is form valid?", valid);
        if (valid) {
          //console.log("Submitting valid form for", model, form);
          Promise.resolve(onSubmit(form))
            .then(resp => {
              dispatch(formActions.setSubmitted, true)

              return resp
            })
            .catch(error => {
              dispatch(formActions.setSubmitFailed(model))
              //console.log("Caught error", error);
              const resp = error.response

              //402 is a validation error
              if (resp && resp.status === 402) {
                resp
                  .json()
                  .then(errors => {
                    console.log('Validation errors are', errors)

                    if (onValidationErrors) {
                      onValidationErrors(errors)
                    } else {
                      dispatch(publishErrors(model, errors))
                    }
                  })
                  .catch(error => {
                    console.log('Could not get JSON from error response', resp, error)
                  })
              } else {
                //console.log(`Something else`, error);
                throw resp
              }
            })
        } else {
          /*
           * console.log("Won't submit invalid form for", model, form);
           * Set submitted, even though we don't call onSubmit, so errors will appear
           */
          dispatch(formActions.setSubmitFailed(model))
        }
      })
    }
    const rest = props

    delete rest.validate
    delete rest.forceValidate
    delete rest.modelValues

    let error = null

    if (errors) {
      for (const key in errors) {
        error = error[key]
        break
      }
    }

    const self = this

    return (
      <div>
        {error && <div className="alert alert-warning">{error}</div>}
        <ReactReduxForm
          noValidate={true}
          model={model}
          onChange={enhancedOnChange}
          onSubmit={enhancedOnSubmit}
          {...rest}>
          {children(self)}
        </ReactReduxForm>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect((state, props) => {
  const modelValues = getModel(state, props.model)
  const form = getField(state, props.model)

  /*
   * console.log("Form is", form);
   * const formState = getField(state, props.model);
   * console.log("Form is", formState);
   */
  return {
    modelValues,
    errors: form && form.errors
  }
}, mapDispatchToProps)(Form)
